import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconForwardStyle0 = cosmosIconCss;

const CosmosIconForward$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconForward extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4617f8d89e42fd9bdd2c431c3d4090cdf297b8a7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '83e9f82be3b4de9292da56cb084354172705154d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '52d6a4e58aa576b713ac070594e171e137e26df8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 11.518 5.72 16.44A.5.5 0 0 1 5 16V6a.49.49 0 0 1 .72-.46L12 10.462V6a.49.49 0 0 1 .72-.46l6.38 5a.5.5 0 0 1 0 .9l-6.38 5A.5.5 0 0 1 12 16v-4.482Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconForwardStyle0; }
}, [1, "cosmos-icon-forward", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-forward"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-forward":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconForward$1);
            }
            break;
    } });
}

const CosmosIconForward = CosmosIconForward$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconForward, defineCustomElement };
